var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 113,
    viewBox: "0 0 195 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07885,
    y: 0.342526,
    width: 192.815,
    height: 25.8149,
    rx: 8.78994,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.185051
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73438 4.87629C1.73438 2.32126 3.80563 0.25 6.36066 0.25H190.136C192.691 0.25 194.762 2.32126 194.762 4.87629H1.73438Z",
    fill: "#2A66BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.38672,
    y: 10.6133,
    width: 90.8612,
    height: 7.95721,
    rx: 3.97861,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.07885,
    y: 29.4958,
    width: 193.591,
    height: 45.5876,
    rx: 8.78994,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5977,
    y: 35.709,
    width: 169,
    height: 6,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1855,
    y: 46.4385,
    width: 34.9747,
    height: 4.25618,
    rx: 2.12809,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8752,
    y: 46.7161,
    width: 3.70103,
    height: 3.70103,
    rx: 1.85051,
    fill: "white",
    stroke: "#2A66BC",
    strokeWidth: 0.555154
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.707,
    y: 47.5488,
    width: 2.03557,
    height: 2.03557,
    rx: 1.01778,
    fill: "#2A66BC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.373,
    y: 55.5645,
    width: 84,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8752,
    y: 55.7024,
    width: 3.70103,
    height: 3.70103,
    rx: 1.85051,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.555154
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.373,
    y: 64.8691,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8752,
    y: 64.6877,
    width: 3.70103,
    height: 3.70103,
    rx: 1.85051,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.555154
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1.07885,
    y: 29.4958,
    width: 193.591,
    height: 45.5876,
    rx: 8.78994,
    stroke: "#D9D9D9",
    strokeWidth: 0.185051
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1.07885,
    y: 78.4216,
    width: 193.591,
    height: 34.0422,
    rx: 8.78994,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5977,
    y: 84.6348,
    width: 169,
    height: 6,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0977,
    y: 95.8652,
    width: 76.7754,
    height: 9.8855,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.07885,
    y: 78.4216,
    width: 193.591,
    height: 34.0422,
    rx: 8.78994,
    stroke: "#D9D9D9",
    strokeWidth: 0.185051
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.4bc3883fda35c07da67e5f26f9df549f.svg";
export { ForwardRef as ReactComponent };